import * as API_CONSTANT from "../constants";

export const getAllDashboard= () =>
    fetch(`${API_CONSTANT.cnp_v1_fe_path}/dashboard/get/all`, {
      method: "POST",
      headers: API_CONSTANT.headers,
      body: JSON.stringify({}),
    }).then((res) => res.json());

export const getDashboardTimeFrameDaily = ({ startTime, endTime }) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/dashboard/timeframe/daily/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      startTime,
      endTime,
    }),
  }).then((res) => res.json());

export const getDashboardTimeFrameMonthly = ({ startTime, endTime }) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/dashboard/timeframe/monthly/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      startTime,
      endTime,
    }),
  }).then((res) => res.json());